export class PlantIdReq {
    plantId: number;
    constructor(
        plantId: number,
    ){
        this.plantId = plantId
    }
}
